export default {"src":"/_next/static/media/profile_pic_placeholder.444a9e41.svg","height":99,"width":90};